export default {
    checkbox: 'Осмотр товара произведен',
    feedback: 'Поле обязательно для заполнения!',
    saveButton: 'Сформировать возврат',

    fields: {
        id: 'Номер операции',
        orderId: 'Номер заказа',
        refundType: 'Тип возврата средств',
        refundDate: 'Дата операции',
        refundStatus: 'Статус возврата',
        exchangeReasonDescription: 'Причина обмена',
        exchangeDate: 'Дата операции',
        partnerName: 'Наименование партнёра',
    },
};